import { useAtomValue } from "jotai";
import { RefObject } from "react";
import { ScrollView } from "react-native";

import { DiningBookingWizard } from "@/features/BookingWizard/DiningBookingWizard/types";

import { DiningBookingWizardCurrentStepAtom } from "../../atoms/stores";
import { DiningAddKnownPeopleStep } from "./steps/DiningAddKnownPeopleStep/DiningAddKnownPeopleStep";
import { DiningWizardDetailStep } from "./steps/DiningWizardDetailStep/DiningWizardDetailStep";

type Props = {
  diningDietaryTags: DiningBookingWizard.DiningBookingWizardData["dietaryTags"];
  diningOccasionTags: DiningBookingWizard.DiningBookingWizardData["occasionTags"];
  startSlotId: string | null;
  scrollViewRef: RefObject<ScrollView | null>;
};

export const DiningBookingWizardStepContainer = ({
  diningDietaryTags,
  diningOccasionTags,
  startSlotId,
  scrollViewRef,
}: Props) => {
  const currentStep = useAtomValue(DiningBookingWizardCurrentStepAtom);

  switch (currentStep) {
    case "DiningAddKnownPeopleStep":
      return <DiningAddKnownPeopleStep startSlotId={startSlotId} />;
    case "DiningWizardDetailStep":
      return (
        <DiningWizardDetailStep
          diningDietaryTags={diningDietaryTags}
          diningOccasionTags={diningOccasionTags}
          scrollViewRef={scrollViewRef}
        />
      );
    default:
      return null;
  }
};
